import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import formMixin from '../../formMixin';
import get from 'lodash/get';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicDevicetypesPacketParserMulti',
  mixins: [formMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    hidePredefinedParserSelection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      formComponent: null,
      parserPath: null,
      showFormDialog: false,
      parserDuplicateKeysPrompt: false,
      // for display, keep the data separated from `parserConfigInternal`
      // only update from __switch parser if the user hits `Save`
      switchParsers: {},
      parserConfigInternal: {},
      lastEmittedConfig: {}
    };
  },
  computed: {
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    },
    formElement: function formElement() {
      return this.formComponent;
    },
    dialogButtons: function dialogButtons() {
      return [{
        icon: 'fal fa-check-square',
        title: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.presave'),
        action: 'save',
        type: this.isIotHubManager ? 'submit' : 'button',
        valid: this.isIotHubManager ? undefined : false
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    dialogTitle: function dialogTitle() {
      if (this.parserPath === '__switch') {
        return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.editSwitchParser');
      } else if (this.parserPath === '__default') {
        return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.editDefaultParser');
      }

      return this.parserPath;
    },
    switchParserList: function switchParserList() {
      return Object.keys(this.switchParsers).filter(function (p) {
        return p !== '__switch' && p !== '__default';
      }).sort(function (a, b) {
        return a.localeCompare(b);
      });
    }
  },
  watch: {
    parserConfig: {
      handler: function handler(val) {
        if (!val) {
          this.parserConfigInternal = {};
          return;
        }

        this.parserConfigInternal = cloneDeep(val);
      },
      deep: true,
      immediate: true
    },
    parserConfigInternal: function parserConfigInternal() {
      this.updateSwitchParsers();
    }
  },
  created: function created() {
    this.updateSwitchParsers();
  },
  methods: {
    generateCopyName: function generateCopyName(name) {
      var matchCopy = name.match(/_(\d+)$/) || [];
      var copyNum = parseInt(matchCopy[1], 10);

      if (!copyNum) {
        return "".concat(name, "_1");
      }

      return name.replace(/_(\d)$/, "_".concat(copyNum + 1));
    },
    duplicateParser: function duplicateParser(parser) {
      var dupeName = parser; // look if the dupeName is already used in the switchParserList and if so the next one

      while (this.switchParserList.indexOf(dupeName) >= 0) {
        dupeName = this.generateCopyName(dupeName);
      }

      var switchParserEntry = find(this.parserConfigInternal.__switch.calculateElements, {
        target: parser
      });

      this.parserConfigInternal.__switch.calculateElements.push({
        target: dupeName,
        formula: switchParserEntry.formula
      });

      this.switchParsers.__switch.calculateElements.push({
        target: dupeName,
        formula: switchParserEntry.formula
      });

      this.switchParserList.push(dupeName);
      this.switchParsers[dupeName] = cloneDeep(this.switchParsers[parser]);
      this.parserConfigInternal[dupeName] = cloneDeep(this.parserConfigInternal[parser]);
      this.updateSwitchParsers();
    },
    editParser: function editParser(path) {
      var _this = this;

      this.parserPath = path;

      if (!this.parserConfigInternal[path]) {
        this.parserConfigInternal[path] = {};
      }

      this.parserConfigInternal[path].variables = get(this.parserConfigInternal, "".concat(path, ".variables")) || {};
      this.parserConfigInternal[path].calculateElements = get(this.parserConfigInternal, "".concat(path, ".calculateElements")) || [];
      this.updateSwitchParsers();
      this.$nextTick(function () {
        _this.formComponent = path === '__switch' ? get(_this.$refs, 'form') : get(_this.$refs, 'single-parser.$refs.form');
      });
      this.showFormDialog = true;
    },
    formulaForSwitchParser: function formulaForSwitchParser(switchParser) {
      return (get(this.switchParsers, '__switch.calculateElements', []).find(function (ce) {
        return ce.target === switchParser;
      }) || {}).formula;
    },
    updateSwitchParsers: function updateSwitchParsers() {
      var _this2 = this;

      var updatedSwitchParsers = cloneDeep(this.parserConfigInternal); // keep switch switch-variables and parsers in sync
      // step 1: add

      var calculateElements = get(this.parserConfigInternal, '__switch.calculateElements', []);
      calculateElements.forEach(function (element) {
        updatedSwitchParsers[element.target] = updatedSwitchParsers[element.target] || _this2.parserConfigInternal[element.target] || {
          variables: {},
          calculateElements: []
        };
      }); // step 2: delete

      Object.keys(updatedSwitchParsers).forEach(function (parser) {
        if (parser !== '__switch' && parser !== '__default') {
          if (calculateElements.findIndex(function (e) {
            return e.target === parser;
          }) === -1) {
            delete updatedSwitchParsers[parser];
          }
        }
      });
      updatedSwitchParsers['__default'] = cloneDeep(this.parserConfigInternal['__default'] || updatedSwitchParsers['__default'] || {
        variables: {},
        calculateElements: []
      });
      this.switchParsers = cloneDeep(updatedSwitchParsers); // this.parserConfigInternal = cloneDeep(updatedSwitchParsers);
    },
    onparserConfigInternalUpdated: function onparserConfigInternalUpdated(val) {
      var clonedConfig = cloneDeep(this.parserConfigInternal);
      clonedConfig[this.parserPath] = cloneDeep(val);
      this.parserConfigInternal = clonedConfig;
    },
    saveParserPreflight: function saveParserPreflight() {
      var calculations = get(this.switchParsers[this.parserPath], 'calculateElements', []);
      var lowercase_keys = calculations.map(function (entry) {
        return entry.target.toLowerCase();
      });
      var unique_keys = new Set(lowercase_keys);

      if (lowercase_keys.length !== unique_keys.size) {
        this.parserDuplicateKeysPrompt = true;
        return;
      }

      this.save();
    },
    save: function save() {
      this.parserConfigInternal[this.parserPath] = this.switchParsers[this.parserPath];
      this.emitChanges(); // NOTE: there is the "save" button outside of this component in `wrapper.vue`
      // so do not perform actual saving to the back-end here, this is just a "runtime save" of edited dialog content

      if (this.parserPath === '__switch') {
        this.updateSwitchParsers();
      }

      this.showFormDialog = false;
    },
    emitChanges: function emitChanges() {
      var clonedparserConfigInternal = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', clonedparserConfigInternal);
    }
  }
};